import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
  input,
  model,
  OnInit,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { Option } from './models';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { debounceTime, distinctUntilChanged, fromEvent, map, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'edt-search',
  imports: [CdkConnectedOverlay],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search.component.html',
  styleUrl: './search.component.css',
})
export class SearchComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);

  /* Opciones de configuracion general */
  placeHolder = input<string>('Buscar...');
  prefix = input<boolean>(false);
  sufix = input<boolean>(true);
  searchInput = viewChild.required<ElementRef<HTMLInputElement>>('searchInput');
  searchValue = signal<string>('');
  /* TODO: Mostrar estado carga */
  // isLoading = input<boolean>(false); /* TODO: implement */

  /* Permite mostrar sugerencias */
  allowSuggestions = input<boolean>(false);
  suggestionOptions = input<Option[]>([]);
  // overlayTpl = viewChild(CdkConnectedOverlay);

  /* En caso de que sea verdadero la búsqueda se realizará automáticamente cuando de que usuario escriba, on un retardo de delayAutoSearchTime */
  autoSearch = input<boolean>(false);
  delayAutoSearchTime = input<number>(500);
  closedByUser = signal<boolean>(false);
  isOpen = computed(() => {
    const val = this.searchValue();
    return (val && val.length > 3 ? true : false) && !this.closedByUser();
  });

  /* Solo se permite si autoSearch es falso */
  autoClean = input<boolean>(false);

  showHistory = input<boolean>(false);
  historyOptions = signal<Option[]>([]);
  historyOptionsMap = new Map<string, Option>();

  /* TODO: Mejorar estilos */
  /* searchContainerStyles = input<ElementStyles>({
    height: '24px',
    'background-color': 'blue',
  });
  inputContainerStyles = input<ElementStyles>({
    height: '24px',
    'background-color': 'blue',
  });
  inputStyles = input<ElementStyles>({
    height: '24px',
    'background-color': 'blue',
  }); */

  /* TODO: Implements */
  /* Configure and emit when a compact mode is changed */
  compact = model<boolean>(false);

  /* TODO: Permitir proyectar icono de busqueda */
  /* TODO: Permitir proyectar opciones de autocompletado*/
  // Custom templates
  /* itemTemplate = input<TemplateRef<unknown>>;
  notFoundTemplate = input<TemplateRef<unknown>>;
  customTemplate = contentChild<TemplateRef<unknown>>(TemplateRef); */

  /* OUTPUTS */
  /* Event is emitted when an item from the list is selected. */
  optionSelected = output<Option>();

  /* Event is emitted when an input is changed. */
  inputChanged = output<string>();

  /* Event is emitted when an input is cleared. */
  inputCleared = output<boolean>();

  /* Event is emitted when the autocomplete panel is opened. */
  opened = output<boolean>();

  ngOnInit(): void {
    this._observeSearchInput();
    this._observeChangeEmition();
  }

  /* Toggle compact mode  */
  toggleCompact(): void {
    this.compact.update(val => !val);
  }

  selectedOption(it: Option): void {
    this.optionSelected.emit(it);
    if (this.searchInput().nativeElement) {
      this.searchInput().nativeElement.value = it.label;
    }
    this.searchValue.set(this.searchInput().nativeElement.value ?? '');
    this.closeOverlay();
  }

  manualSearch(): void {
    const rta = this.searchInput().nativeElement.value ?? '';
    if (this.autoSearch()) {
      return;
    }
    if (this.autoClean()) {
      this.searchInput().nativeElement.value = '';
    }
    this.inputChanged.emit(rta);
  }

  clearInput(): void {
    this.overlayDetached();
    this.searchInput().nativeElement.value = '';
    this.searchValue.set('');
    this.inputCleared.emit(true);
  }

  overlayDetached(): void {
    this.opened.emit(this.isOpen());
  }

  closeOverlay(): void {
    this.closedByUser.set(true);
  }

  autoSearching(ev: Event): void {
    const val = (ev.target as HTMLInputElement).value;
    if (!this.autoSearch()) {
      return;
    }
    this.inputChanged.emit(val);
  }

  private _observeSearchInput(): void {
    const inp = this.searchInput().nativeElement;
    if (inp) {
      const search$ = fromEvent(inp, 'keyup').pipe(
        map((event: Event) => (event.target as HTMLInputElement).value),
        tap(val => {
          this.searchValue.set(val.trim());
          if (val.trim().length > 3) {
            this.closedByUser.set(false);
          }
        }),
        debounceTime(this.delayAutoSearchTime()),
        map(val => val.trim()),
        distinctUntilChanged(),
        tap(val => {
          if (this.autoSearch()) {
            this.inputChanged.emit(val.trimEnd().trimStart());
          }
        }),
        takeUntilDestroyed(this._destroyRef)
      );

      search$.subscribe();
    }
  }

  private _observeChangeEmition(): void {
    const tmpHistory: Option[] = this.historyOptions();
    this.inputChanged.subscribe(val => {
      if (!this.autoSearch() && !this.historyOptionsMap.has(val)) {
        tmpHistory.push({ label: val, value: val });
        this.historyOptions.set(tmpHistory);
        this.historyOptionsMap.set(val, { label: val, value: val });
      }
    });
  }
}
